/* Mobile presentation only. Shopify remains the source of line keys and allocations. */
(() => {
  'use strict';
  if (window.TorqueCartGroups) return;
  const media = window.matchMedia('(max-width: 720px)');
  const identity = item => JSON.stringify([
    item.variant, item.plan || null,
    Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)),
  ]);
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency, currencyDisplay: 'narrowSymbol',
  }).format(amount / 100);

  function reset(root) {
    root?.querySelectorAll('[data-mobile-cart-group]').forEach(row => row.remove());
    root?.querySelectorAll('[data-mobile-cart-source]').forEach(row => {
      row.hidden = false;
      delete row.dataset.mobileCartSource;
    });
  }

  function render(root) {
    if (!root) return;
    reset(root);
    if (!media.matches) return;
    const groups = new Map();
    root.querySelectorAll('[data-cart-group-data]').forEach(script => {
      let item;
      try { item = JSON.parse(script.textContent); } catch { return; }
      if (!item.variant || !item.key || !item.currency) return;
      const key = identity(item);
      const group = groups.get(key) || [];
      group.push({ item, row: script.parentElement });
      groups.set(key, group);
    });
    for (const [key, members] of groups) {
      if (members.length < 2) continue;
      const row = members[0].row.cloneNode(true);
      const drawer = row.hasAttribute('data-drawer-key');
      row.querySelector('[data-cart-group-data]').remove();
      row.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      // Keep the original updates[] controls intact for the native form fallback.
      row.querySelectorAll('input[name]').forEach(node => node.removeAttribute('name'));
      row.dataset.mobileCartGroup = key;
      row.dataset.mobileCartMembers = JSON.stringify(members.map(({ item }) => ({ key: item.key, quantity: item.quantity })));
      const quantity = members.reduce((sum, { item }) => sum + item.quantity, 0);
      const final = members.reduce((sum, { item }) => sum + item.final, 0);
      const original = members.reduce((sum, { item }) => sum + item.original, 0);
      const currency = members[0].item.currency;
      if (drawer) {
        row.querySelector('.tq-drawer__quantity span').textContent = String(quantity);
        const controls = row.querySelectorAll('[data-drawer-quantity]');
        controls[0].dataset.drawerQuantity = String(quantity - 1);
        controls[1].dataset.drawerQuantity = String(quantity + 1);
        // A grouped row has at least two units, so use the decrease label, not remove.
        controls[0].setAttribute('aria-label', controls[0].dataset.drawerDecreaseLabel);
      } else {
        const input = row.querySelector('[data-qty-input]');
        input.value = String(quantity);
        input.dataset.lastValue = String(quantity);
      }
      const price = row.querySelector(drawer ? '.tq-drawer__price' : '.tq-line__price');
      const amount = document.createElement('span');
      if (!drawer) amount.className = 'tq-line__final';
      amount.textContent = money(final, currency);
      price.replaceChildren(amount);
      if (original > final) {
        const was = document.createElement('s');
        was.textContent = money(original, currency);
        price.append(' ', was);
      }
      row.querySelectorAll('.tq-line__discounts, .tq-drawer__discount').forEach(node => node.remove());
      const discounts = new Map();
      members.forEach(({ item }) => item.discounts.forEach(discount => {
        discounts.set(discount.title, (discounts.get(discount.title) || 0) + discount.amount);
      }));
      const list = document.createElement(drawer ? 'div' : 'ul');
      if (!drawer) { list.className = 'tq-line__discounts'; list.setAttribute('role', 'list'); }
      for (const [title, amount] of discounts) {
        if (amount <= 0) continue;
        const discount = document.createElement(drawer ? 'p' : 'li');
        if (drawer) discount.className = 'tq-drawer__discount';
        discount.textContent = `${title} −${money(amount, currency)}`;
        list.append(discount);
      }
      if (list.childElementCount) {
        const controls = row.querySelector(drawer ? '.tq-drawer__quantity' : '.tq-line__controls');
        controls.before(list);
      }
      members[0].row.before(row);
      members.forEach(({ row: source }) => { source.hidden = true; source.dataset.mobileCartSource = ''; });
    }
  }

  function request(row, quantity) {
    if (!row?.hasAttribute('data-mobile-cart-group')) return null;
    const members = JSON.parse(row.dataset.mobileCartMembers);
    const current = members.reduce((sum, item) => sum + item.quantity, 0);
    const updates = {};
    if (quantity >= current) {
      // Increases use change.js so Shopify enforces available inventory.
      return { id: members[0].key, quantity: members[0].quantity + quantity - current };
    }
    let remove = current - quantity;
    for (const item of [...members].reverse()) {
      const reduction = Math.min(remove, item.quantity);
      if (reduction) updates[item.key] = item.quantity - reduction;
      remove -= reduction;
    }
    const entries = Object.entries(updates);
    if (entries.length === 1) return { id: entries[0][0], quantity: entries[0][1] };
    // Only decreases/removals need a multi-key update; never send variant IDs.
    return { updates };
  }
  window.TorqueCartGroups = { render, reset, request };
  media.addEventListener('change', () => {
    document.querySelectorAll('[data-cart-root].is-enhanced, #TorqueCartDrawer').forEach(render);
  });
})();
